import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { UserAuthorizationGroupSetService } from './api/userAuthorizationGroupSet.service';
import { UserRolesSetService } from './api/userRolesSet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class UserMaterialApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<UserMaterialApiModule> {
        return {
            ngModule: UserMaterialApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: UserMaterialApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('UserMaterialApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
